import { render } from "./App.vue?vue&type=template&id=49dc7dec"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=49dc7dec&lang=css"

import exportComponent from "/home/simon/workspace/tasman/3palette/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__